import { MouseEventHandler } from "react";

type TProps = {
  style: React.HTMLAttributes<HTMLDivElement>["style"];
  onClick?: MouseEventHandler<HTMLDivElement> | undefined;
};

const PlayVideoIcon: React.FC<TProps> = ({ style, onClick }) => {
  return (
    <div style={style} onClick={onClick}>
      <svg
        width="81"
        height="80"
        viewBox="0 0 81 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M40.8398 0C18.7478 0 0.839844 17.908 0.839844 40C0.839844 62.092 18.7478 80 40.8398 80C62.9318 80 80.8398 62.092 80.8398 40C80.8398 17.908 62.9318 0 40.8398 0ZM31.9961 24.3086C32.4741 24.3086 32.9544 24.4223 33.3984 24.6562L57.5039 37.3477C58.4939 37.8677 59.1075 38.8859 59.1055 40.0039C59.1055 41.1219 58.4939 42.1362 57.5039 42.6562L33.3984 55.3438C32.9564 55.5757 32.4741 55.6914 31.9961 55.6914C31.4601 55.6914 30.9272 55.5458 30.4492 55.2578C29.5412 54.7098 29 53.7475 29 52.6875V27.3125C29 26.2525 29.5412 25.2902 30.4492 24.7422C30.9272 24.4522 31.4621 24.3086 31.9961 24.3086Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default PlayVideoIcon;
